/**
 * Toggle / synchronizer tools (ReferenceLines, ImageOverlay, slice sync, etc.) do not set `isActive`
 * on ToolButton — only `className`. When on, use the same *tile + ink* read as primary tools with
 * `isActive` (see viewer `data-active` overrides on `.viewer-ris-toolbar`), not teal `text-primary` alone.
 */
const getToggledClassName = isToggled => {
  return isToggled
    ? '!bg-muted !text-foreground hover:!bg-accent hover:!text-foreground'
    : '!text-foreground hover:!bg-muted/80 hover:!text-highlight';
};

export { getToggledClassName };
